module.exports = __webpack_public_path__ + "img/info-filled-light.3218d65.svg";